(function () {
    'use strict';

    angular
        .module('app')
        .factory('localViewerOptionsService', localViewerOptionsService);

    localViewerOptionsService.$inject = ['$http', '$q'];

    function localViewerOptionsService($http, $q) {
        var service = {
            getLocalViewerSettings: getLocalViewerSettings,
            setLocalViewerSettings: setLocalViewerSettings,
            processing: false,
        };

        return service;


        // Gets all of the local viewer settings
        function getLocalViewerSettings() {
            service.processing = true;
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/api/AdminOptions/LocalViewerSettings/').then(function (response) {
                service.processing = false;
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }

        // Sets all of the local viewer settings
        function setLocalViewerSettings(viewerSettings) {
            var request = $http({
                beforeSend: function (xhr) {
                    xhr.setRequestHeader("Content-Type", "application/json");
                },
                method: 'PUT',
                dataType: 'json',
                contentType: 'application/json',
                crossDomain: true,
                cache: false,
                url: '../Synergis.WebApi/api/AdminOptions/LocalViewerSettings',
                data: JSON.stringify(viewerSettings)
            }, function (err, status) {
                console.info('setLocalViewerSettings error', err, status);
            });
            return request;
        }
    }
})();